import type { ApiData, MediaCategory } from '~/types/site-api'

import { buildMediaCategoryTree } from '~/utils/content'

/**
 * 站点媒体分类：将接口平铺分类转换成导航与媒体页面使用的树。
 */
export function useMediaCategories() {
  const { getMediaCategories } = useSiteApi()
  const asyncData = useAsyncData<ApiData<MediaCategory[]>>(
    'site-media-categories',
    (_nuxtApp, { signal }) => getMediaCategories(signal),
    {
      dedupe: 'defer',
      getCachedData(key, nuxtApp) {
        return nuxtApp.payload.data[key] as ApiData<MediaCategory[]> | undefined
      },
      default: () => ({ data: [] as MediaCategory[] }),
    }
  )

  const categoryTree = computed(() => buildMediaCategoryTree(asyncData.data.value?.data ?? []))

  return Object.assign(asyncData, { categoryTree })
}
